var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationArrow = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.004 13.71 2.15 2.15l11.56 3.853-4.909 2.053c-.336.14-.604.408-.745.745L6.004 13.71Z"
})));
SvgLocationArrow.viewBox = '0 0 16 16';
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationArrow);
export default ForwardRef;